import React from 'react';
import { ContentfulImage, ContentfulRichText } from 'common/components';
import PropTypes from 'prop-types';
import CTAButton from './CTAButton';
import DateBadge from './DateBadge';
import { formatEventDate, parseEventDate } from '../utils/utils';

const BaseEventCard = ({ event, classNames, variant }) => {
  const startDate = parseEventDate(event.schedules?.[0]?.startDate);
  const endDate = parseEventDate(event.schedules?.[0]?.endDate);

  const renderCTAs = () => {
    if (variant === 'featured') {
      return (
        <>
          {event.type && (
            <CTAButton
              text={event.type}
              link={event.url}
              variant="primary-card"
            />
          )}
          <CTAButton
            text="Learn More"
            link={event.slug}
            variant="secondary-card"
          />
        </>
      );
    }
    return <CTAButton text="Learn More" link={event.slug} variant="general" />;
  };

  const handleCardClick = (e) => {
    if (e.target.closest('a')) {
      e.preventDefault();
      return;
    }
    window.location.href = event.slug;
  };

  return (
    <div
      className={classNames('container')}
      onClick={handleCardClick}
      style={{ cursor: 'pointer' }}>
      <div className={classNames('image-container')}>
        <ContentfulImage field={event.images} className={classNames('image')} />
      </div>

      <div className={classNames('content')}>
        <div className={classNames('dates')}>
          {startDate && (
            <div className={classNames('date-range')}>
              {formatEventDate(startDate, endDate)}
            </div>
          )}
          <div className={classNames('date-badge')}>
            <DateBadge schedule={event.schedules} />
          </div>
        </div>

        <div className={classNames('title')}>{event.title}</div>

        <div className={classNames('description')}>
          <ContentfulRichText field={event.shortDescription} />
        </div>

        <div
          className={classNames('ctas')}
          onClick={(e) => e.stopPropagation()}>
          {renderCTAs()}
        </div>
      </div>
    </div>
  );
};

BaseEventCard.propTypes = {
  event: PropTypes.object.isRequired,
  classNames: PropTypes.func.isRequired,
  variant: PropTypes.string,
};

export default BaseEventCard;
